const storageTag = 'UpRekreaRefundToken';

export function parseToken() {
    const token = localStorage.getItem(storageTag);

    return token ?? false;
}

export function saveToken(token) {
    return new Promise((resolve) => {
        localStorage.setItem(storageTag, token);
        resolve();
    });
}

export function deleteToken() {
    return new Promise((resolve) => {
        localStorage.removeItem(storageTag);
        resolve();
    });
}